"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Loader_vue_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/components/Loader.vue"));
const FieldsSetupFlowController_1 = __importDefault(require("../../modules/controllers/FieldsSetupFlowController"));
const ViewZero_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ViewZero.vue"));
let ProviderFields = class ProviderFields extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.FIELDS_SETUP_FLOW_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.FIELDS_SETUP_FLOW_CONTROLLER.providersStep;
        this.NEXT_STEP_CONTROLLER = this.FIELDS_SETUP_FLOW_CONTROLLER.fieldsPreviewTableStep;
        this.loadingProviderFields = true;
        this.isCheckedGlobal = false;
        this.loading = false;
        this.loaderSearch = false;
        this.fieldsChecked = [];
        this.textFilter = '';
        this.fieldsFilters = [];
        this.loadingGetAll = false;
    }
    async getAllFieldsToProvider() {
        this.loadingGetAll = true;
        await this.provider.getAllFields();
        this.NEXT_STEP_CONTROLLER.addFields(this.provider.fields.filter((providerField) => providerField.geodata));
        this.FIELDS_SETUP_FLOW_CONTROLLER.setCurrentStep(this.NEXT_STEP_CONTROLLER);
        let mode = (this.FIELDS_SETUP_FLOW_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
        this.FIELDS_SETUP_FLOW_CONTROLLER.logActivity({
            'name': `Farm ${mode} Step 2 Completed: Field Selection`,
            'status': 'ok',
            'props': {
                'workflow': `integration-${this.provider.name.toLowerCase()}`,
                'fullImport': true
            }
        });
        this.loadingGetAll = false;
    }
    get paginationCurrentPage() {
        return this.provider.currentPage + 1;
    }
    get currentPage() {
        return this.provider.currentPage;
    }
    async loadPage(page) {
        this.loadingProviderFields = true;
        this.textFilter = '';
        this.fieldsFilters = [];
        const pageM = page - 1;
        if (this.provider.fieldsPages.some(entry => entry.page === pageM)) {
            this.provider.fieldsP = this.provider.fieldsPages.find((farmPage) => { return farmPage.page === pageM; }).farms;
            this.provider.currentPage = pageM;
        }
        else {
            await this.provider.getFields(pageM);
        }
        this.STEP_CONTROLLER.resetSelectedFields();
        this.isCheckedGlobal = true;
        this.checkedGlobalObserver();
        this.loadingProviderFields = false;
    }
    get fields() {
        return this.STEP_CONTROLLER.data.fields;
    }
    onSearchChange(f) {
        this.loaderSearch = true;
        this.textFilter = f;
        if (f.length > 0) {
            this.fieldsFilters = this.provider.fields
                .filter((field) => field.fieldName
                .toUpperCase()
                .includes(f.toUpperCase()) ||
                field.farmName
                    .toUpperCase()
                    .includes(f.toUpperCase()))
                .map((sam) => sam);
        }
        else {
            this.textFilter = null;
            this.fieldsFilters = this.provider.fields;
        }
        setTimeout(() => {
            this.loaderSearch = false;
        }, 500);
    }
    isFieldCheck(fieldId) {
        if (this.fieldsChecked.includes(fieldId)) {
            return true;
        }
        return false;
    }
    checkedGlobalObserver() {
        if (this.isCheckedGlobal) {
            this.STEP_CONTROLLER.resetSelectedFields();
            for (const field of this.fieldsFilters.length > 0 && this.textFilter ? this.fieldsFilters : this.provider.fieldsP) {
                if (field.geodata.length > 0) {
                    this.fieldsChecked.push(field.id);
                    this.STEP_CONTROLLER.addSelectedFields(field);
                }
            }
        }
        else if (!this.isCheckedGlobal) {
            this.STEP_CONTROLLER.resetSelectedFields();
            this.fieldsChecked = [];
        }
    }
    changeIsCheckedGlobal(newValue) {
        this.isCheckedGlobal = newValue;
        if (!this.isCheckedGlobal)
            this.fieldsChecked = [];
    }
    closeModal() {
        this.fieldsChecked = [];
        this.textFilter = '';
        this.fieldsFilters = [];
        this.$emit('closeModal');
    }
    goNextStep() {
        this.NEXT_STEP_CONTROLLER.addFields(this.STEP_CONTROLLER.data.selectedFields);
        this.FIELDS_SETUP_FLOW_CONTROLLER.setCurrentStep(this.NEXT_STEP_CONTROLLER);
        let mode = (this.FIELDS_SETUP_FLOW_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
        this.FIELDS_SETUP_FLOW_CONTROLLER.logActivity({
            'name': `Farm ${mode} Step 2 Completed: Field Selection`,
            'status': 'ok',
            'props': {
                'workflow': `integration-${this.provider.name.toLowerCase()}`,
                'fullImport': false
            }
        });
    }
    //TODO: Remove filter
    async fetchProviderFields() {
        this.loadingProviderFields = true;
        await this.provider.getFields(0);
        this.loadingProviderFields = false;
    }
    async mounted() {
        this.STEP_CONTROLLER.resetFields();
        this.provider.reset();
        if (this.provider.fields.length < 1) {
            await this.fetchProviderFields();
        }
        this.isCheckedGlobal = true;
        this.checkedGlobalObserver();
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 35, 35);
    }
    parcelFillColor(field) {
        var _a;
        if (field.crop) {
            return `${(_a = field.crop) === null || _a === void 0 ? void 0 : _a.color}50`;
        }
        else
            return '#eebb5450';
    }
    parcelStrokeColor(field) {
        var _a;
        if (field.crop) {
            return (_a = field.crop) === null || _a === void 0 ? void 0 : _a.color;
        }
        else
            return '#eebb54';
    }
    selectField(field) {
        this.pushFn(field);
    }
    fieldExists(fieldId) {
        return this.STEP_CONTROLLER.data.selectedFields.some(field => field.id === fieldId);
    }
    async pushFn(field) {
        if (this.isCheckedGlobal) {
            this.isCheckedGlobal = false;
        }
        if (this.fieldExists(field.id)) {
            /* this.STEP_MODEL.data.selectedFields = this.STEP_MODEL.data.selectedFields.filter((fieldT)=>{fieldT.id !== field.id}); */
            this.STEP_CONTROLLER.removeSelectedField(field.id);
        }
        else {
            this.STEP_CONTROLLER.addSelectedFields(field);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProviderFields.prototype, "provider", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isCheckedGlobal')
], ProviderFields.prototype, "checkedGlobalObserver", null);
ProviderFields = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { TableBmk: bmk_ui_framework_1.TableBmk, TableHeader: bmk_ui_framework_1.TableHeader, TableHeaderCell: bmk_ui_framework_1.TableHeaderCell, TableBody: bmk_ui_framework_1.TableBody, TableBodyRow: bmk_ui_framework_1.TableBodyRow, TableBodyCell: bmk_ui_framework_1.TableBodyCell, CheckBox: bmk_ui_framework_1.CheckBox, Select: bmk_ui_framework_1.Select, Modal: bmk_ui_framework_1.Modal, Button: bmk_ui_framework_1.Button, Loader: Loader_vue_1.default, Search: bmk_ui_framework_1.Search, Pagination: bmk_ui_framework_1.Pagination, ViewZero: ViewZero_vue_1.default, WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon } })
], ProviderFields);
exports.default = ProviderFields;
